// Notification types enum based on the API
export enum NotificationType {
  GENERIC = "GENERIC",
  WELCOME = "WELCOME",
  ONBOARDING_TIPS = "ONBOARDING_TIPS",
  DAILY_REMINDER = "DAILY_REMINDER",
  WORKOUT_COMPLETION = "WORKOUT_COMPLETION",
  WORKOUT_MILESTONE = "WORKOUT_MILESTONE",
  ACHIEVEMENT = "ACHIEVEMENT",
  SYSTEM = "SYSTEM",
  INACTIVE_USER_REENGAGEMENT = "INACTIVE_USER_REENGAGEMENT",
  WEEKLY_PROGRESS_REMINDER = "WEEKLY_PROGRESS_REMINDER",
}

// DTO for sending notification to a specific user
export interface SendNotificationDto {
  userId: string;
  title: string;
  body: string;
  data?: { [key: string]: string };
  type?: NotificationType;
}

// DTO for broadcasting notification to all users
export interface BroadcastNotificationDto {
  title: string;
  body: string;
  data?: { [key: string]: string };
  type?: NotificationType;
}

// Response interfaces
export interface SendNotificationResponse {
  message: string;
  error: boolean;
  results?: {
    messageId: string;
  };
}

export interface BroadcastNotificationResponse {
  message: string;
  error: boolean;
  results?: {
    totalEligible: number;
    queuedCount: number;
  };
}
